import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProjectCard.css';

interface Project {
  project_id: string;
  name: string;
  description: string;
  created_at: string;
}

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/project/${project.project_id}`);
  };

  return (
    <div className="project-card" title={project.description} onClick={handleClick}>
      <div className="project-header">
        <h3 className="project-name">{project.name}</h3>
        <span className="project-id">#{project.project_id}</span>
      </div>
      <p className="project-description">{project.description}</p>
      <div className="project-footer">
        <span className="created-date">
          {new Date(project.created_at).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};

export default ProjectCard;